import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, CreditCardIcon, SendIcon, CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const steps = [{
  icon: TargetIcon,
  text: 'Vendes tu talento al mercado que paga en dólares'
}, {
  icon: CreditCardIcon,
  text: 'Configuras tu cajero digital con Airtm o Wise'
}, {
  icon: SendIcon,
  text: 'Envías 10 mensajes usando las plantillas y cierras tu primer cliente en menos de 14 días'
}];
const benefits = ['Cómo elegir la habilidad que ya tienes y que alguien en EE.UU. pagaría 10 veces más.', 'Cómo abrir tu cajero digital en dólares en minutos, sin bancos complicados.', 'Cómo conseguir tu primer pago en 14 días o menos, sin saber inglés perfecto.'];
export function SolutionSection() {
  return <section className="py-24 px-4 bg-[#0f0f0f] relative overflow-hidden" data-id="element-147">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#1A7A4A]/50 to-transparent" data-id="element-148" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-[#1A7A4A]/10 blur-[80px] pointer-events-none" data-id="element-149" />

      <div className="max-w-5xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight" data-id="element-152">
            Existe Una Salida: Convertir Tus Habilidades Actuales en{' '}
            <span className="text-[#1A7A4A]" data-id="element-153">Sueldos Globales</span> Sin Dejar
            Tu País
          </h2>
          <p className="text-xl md:text-2xl font-bold text-[#C9A84C]" data-id="element-154">
            La Única Forma de Ganar 4 Veces Más Haciendo Lo Mismo
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-155">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative mx-auto w-full max-w-md" data-id="element-156">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(26,122,74,0.2)]" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/iqScLxDvnJ96ukbXYc5x7a/heylloyd-image-1773159426247.png" alt="Tu Primer Sueldo en Dólares - Manual de 20 páginas para Latinoamérica" className="w-full h-auto object-cover" data-id="element-158" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/30 to-transparent pointer-events-none" data-id="element-159" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-160">
            <p className="text-2xl font-bold text-white mb-4" data-id="element-161">
              Te presento el manual: <br data-id="element-162" />
              <span className="text-[#C9A84C]" data-id="element-163">
                Tu Primer Sueldo en Dólares
              </span>
            </p>
            <p className="text-lg text-[#D1D5DB] mb-8" data-id="element-164">
              Un ebook de solo 20 páginas que elimina la confusión y te da un
              plan paso a paso:
            </p>

            <div className="space-y-4 mb-8" data-id="element-165">
              {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-166">
                  <CheckCircle2Icon className="w-6 h-6 text-[#1A7A4A] flex-shrink-0 mt-0.5" data-id="element-167" />
                  <p className="text-[#D1D5DB]" data-id="element-168">{benefit}</p>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* 3 Steps */}
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-169">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2,
          duration: 0.5
        }} className="bg-[#0A0A0A] border border-neutral-800 p-8 rounded-2xl text-center hover:border-[#1A7A4A]/30 transition-colors" data-id="element-170">
              <div className="w-16 h-16 mx-auto bg-[#0f0f0f] rounded-full flex items-center justify-center mb-6 border border-neutral-800" data-id="element-171">
                <step.icon className="w-8 h-8 text-[#C9A84C]" data-id="element-172" />
              </div>
              <p className="text-lg font-medium text-[#D1D5DB]" data-id="element-173">{step.text}</p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-174">
          <CTAButton text="SÍ, QUIERO GANAR EN DÓLARES" data-id="element-175" />
        </div>
      </div>
    </section>;
}